

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { setResultModalData, showModal } from "../modal/modalSlice";
import axiosInstance from "../../axios/axiosInstance";

const initialState = {

    //! index 1
    nakliyeKaynakData: null,
    isLoadingGetNakliyeKaynakData: false,

    //! index 2
    isLoadingGetNakliyeCityIndex: false,
    cityIndexList: [],

    isLoadingGetTopluCityIndexExcel: false,
    isLoadingUpdateTopluNakliyeCityIndexExcel: false,


    //! index-3
    isLoadingGetNakliyeSeasonIndex: false,
    cityTownSeasonIndex: [],

    isLoadingGetTopluNakliyeSeasonIndexExcel: false,
    isLoadingUpdateTopluNakliyeSeasonIndexExcel: false,
    
    //! index-4 
    isLoadingGetCityToCityIndex: false,
    cityToCityIndex: [],

    isLoadingGetTopluNakliyeCityToCityIndexExcel: false,
    isLoadingUpdateTopluNakliyeCityToCityIndexExcel: false,

    //! index-5
    isLoadingGetCityToTownIndex: false,
    cityToTownIndex: [],

    isLoadingGetTopluNakliyeUpdateCityToTownIndexExcel: false,
    isLoadingUpdateTopluNakliyeCityToTowIndexExcel: false,

    //! index-6
    isLoadingGetNakliyeIklimIndex: false,
    cityIklimIndex: [],

    isLoadingGetTopluNakliyeCityIklimIndexExcel: false,
    isLoadingUpdateTopluNakliyeCityIklimIndexExcel: false,


    //! index-4 all data
    isLoadingGetNakliyeHesaplamaIndex4AllResult: false,
    nakliyeHesaplamaIndex4AllResult: []

}

//! index-1
export const getNakliyeKaynakData = createAsyncThunk("nakliyeIndex/getNakliyeKaynakData", async(_, thunkApi)=> {
    try {
        const {data} = await axiosInstance.get(`/NakliyeKaynakDatas/GetNakliyeKaynakData`)
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})


//! index-1
export const updateNakliyeKaynakData = createAsyncThunk("nakliyeIndex/updateNakliyeKaynakData", async(updatedData, thunkApi)=> {
    try {
        const {data} = await axiosInstance.post(`/NakliyeKaynakDatas/UpdateNakliyeKaynakData`, updatedData)
        if(data.statusCode === 200){
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "Güncelleme İşlemi Başarı ile Gerçekleştirildi", resultType: "success", btnText1: "Görüntüle"}))
        }
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

//! --------------------------------------------------------------------------------------------------

//! index-2
export const getNakliyeCityIndex = createAsyncThunk("nakliyeIndex/getNakliyeCityIndex", async(_, thunkApi)=> {
    try {
        const {data} = await axiosInstance.get(`/NakliyeIndexs/GetNakliyeCityIndex`)
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

//! index-2
export const updateNakliyeCityIndex = createAsyncThunk("nakliyeIndex/updateNakliyeCityIndex", async(updatedList, thunkApi)=> {
    try {
        const {data} = await axiosInstance.post(`/NakliyeIndexs/UpdateNakliyeCityIndex`, updatedList)
        if(data.statusCode === 200){
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "Güncelleme İşlemi Başarı ile Gerçekleştirildi", resultType: "success", btnText1: "Görüntüle"}))
        }
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

//! index-2
export const getTopluCityIndexExcel = createAsyncThunk("nakliyeIndex/getTopluCityIndexExcel", async(_, thunkApi)=> {
    try {
        const {data} = await axiosInstance.get(`/NakliyeIndexs/GetNakliyeCityIndexExcel`)

        const link = document.createElement('a');
        link.href = `${process.env.REACT_APP_API_EXCEL_FILES_URI}${data.data.data}`;
        document.body.appendChild(link)
        link.click();
        document.body.removeChild(link)

        return data
    } catch (error) {
        thunkApi.dispatch(setResultModalData({msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
        return thunkApi.rejectWithValue(error)
    }
  })

//! index-2
  export const updateTopluNakliyeCityIndexExcel = createAsyncThunk("nakliyeIndex/updateTopluNakliyeCityIndexExcel", async(excel, thunkApi)=> {
    try {
          const file = new FormData();
          file.append("file", excel);
        const {data} = await axiosInstance.post(`/NakliyeIndexs/UpdateNakliyeCityIndexExcel`, file)

        return data
    } catch (error) {
        thunkApi.dispatch(setResultModalData({msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
        return thunkApi.rejectWithValue(error)
    }
  })

//! --------------------------------------------------------------------------------------------------


//! index-3
  export const getNakliyeSeasonIndex = createAsyncThunk("nakliyeIndex/getNakliyeSeasonIndex", async(cityId, thunkApi)=> {
    try {
        const token = thunkApi.getState().auth.token
        const config = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }
        const {data} = await axiosInstance.get(`/NakliyeIndexs/GetNakliyeSeasonIndex?CityId=${cityId}`)

        return data
    } catch (error) {
        thunkApi.dispatch(setResultModalData({msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
        return thunkApi.rejectWithValue(error)
    }
  })

//! index-3
  export const updateNakliyeSeasonIndex = createAsyncThunk("nakliyeIndex/updateNakliyeSeasonIndex", async(updatedList, thunkApi)=> {
    try {
        const {data} = await axiosInstance.post(`/NakliyeIndexs/UpdateNakliyeSeasonIndex`, updatedList)
        if(data.statusCode === 200){
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "Güncelleme İşlemi Başarı ile Gerçekleştirildi", resultType: "success", btnText1: "Görüntüle"}))
        }
        return data
    } catch (error) {
        thunkApi.dispatch(setResultModalData({msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
        return thunkApi.rejectWithValue(error)
    }
  })

//! index-3
  export const getTopluNakliyeSeasonIndexExcel = createAsyncThunk("nakliyeIndex/getTopluNakliyeSeasonIndexExcel", async(_, thunkApi)=> {
    try {
        const {data} = await axiosInstance.get(`/NakliyeIndexs/GetNakliyeCityTownSeasonIndexExcel`)

        const link = document.createElement('a');
        link.href = `${process.env.REACT_APP_API_EXCEL_FILES_URI}${data.data.data}`;
        document.body.appendChild(link)
        link.click();
        document.body.removeChild(link)



        return data
    } catch (error) {
        thunkApi.dispatch(setResultModalData({msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
        return thunkApi.rejectWithValue(error)
    }
  })

  //! index-3
  export const updateTopluNakliyeSeasonIndexExcel = createAsyncThunk("nakliyeIndex/updateTopluNakliyeSeasonIndexExcel", async(excel, thunkApi)=> {
    try {
          const file = new FormData();
          file.append("file", excel);
        const {data} = await axiosInstance.post(`/NakliyeIndexs/UpdateNakliyeCityTownSeasonIndexExcel`, file)

        return data
    } catch (error) {
        thunkApi.dispatch(setResultModalData({msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
        return thunkApi.rejectWithValue(error)
    }
  })

//! --------------------------------------------------------------------------------------------------


//! index-4
  export const getCityToCityIndex = createAsyncThunk("nakliyeIndex/getCityToCityIndex", async(cityId, thunkApi)=> {
    try {
        const {data} = await axiosInstance.get(`/NakliyeIndexs/GetCityToCityIndex?CityId=${cityId}`)
        return data
    } catch (error) {
        thunkApi.dispatch(setResultModalData({msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
        return thunkApi.rejectWithValue(error)
    }
  })

//! index-4
  export const updateCityToCityIndex = createAsyncThunk("nakliyeIndex/updateCityToCityIndex", async(updatedList, thunkApi)=> {
    try {
        const {data} = await axiosInstance.post(`/NakliyeIndexs/UpdateCityToCityIndex`, updatedList)
        if(data.statusCode === 200){
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "Güncelleme İşlemi Başarı ile Gerçekleştirildi", resultType: "success", btnText1: "Görüntüle"}))
        }
        return data
        } catch (error) {
            thunkApi.dispatch(setResultModalData({msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
            return thunkApi.rejectWithValue(error)
        }
  })

//! index-4
  export const getTopluNakliyeCityToCityIndexExcel = createAsyncThunk("nakliyeIndex/getTopluNakliyeCityToCityIndexExcel", async(_, thunkApi)=> {
    try {
        const {data} = await axiosInstance.get(`/NakliyeIndexs/GetNakliyeCityToCityIndexExcel`)
        const link = document.createElement('a');
        link.href = `${process.env.REACT_APP_API_EXCEL_FILES_URI}${data.data.data}`;
        document.body.appendChild(link)
        link.click();
        document.body.removeChild(link)
        return data
    } catch (error) {
        thunkApi.dispatch(setResultModalData({msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
        return thunkApi.rejectWithValue(error)
    }
  })

  //! index-4
  export const updateTopluNakliyeCityToCityIndexExcel = createAsyncThunk("nakliyeIndex/updateTopluNakliyeCityToCityIndexExcel", async(excel, thunkApi)=> {
    try {
          const file = new FormData();
          file.append("file", excel);
        const {data} = await axiosInstance.post(`/NakliyeIndexs/UpdateNakliyeCityToCityIndexExcel`, file)

        return data
    } catch (error) {
        thunkApi.dispatch(setResultModalData({msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
        return thunkApi.rejectWithValue(error)
    }
  })

//! --------------------------------------------------------------------------------------------------

//! index-5
  export const getCityToTownIndex = createAsyncThunk("nakliyeIndex/getCityToTownIndex", async(cityId, thunkApi)=> {
    try {
        const {data} = await axiosInstance.get(`/NakliyeIndexs/GetCityToTownIndex?cityId=${cityId}`)
        return data
    } catch (error) {
        thunkApi.dispatch(setResultModalData({msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
        return thunkApi.rejectWithValue(error)
    }
  })

//! index-5
  export const updateCityToTownIndex = createAsyncThunk("nakliyeIndex/updateCityToTownIndex", async(updatedList, thunkApi)=> {
    try {
        const {data} = await axiosInstance.post(`/NakliyeIndexs/UpdateCityToTownIndex`, updatedList )

        if(data.statusCode === 200){
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "Güncelleme İşlemi Başarı ile Gerçekleştirildi", resultType: "success", btnText1: "Görüntüle"}))
        }
        return data
    } catch (error) {
        thunkApi.dispatch(setResultModalData({msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
        return thunkApi.rejectWithValue(error)
    }
  })

  //! index-5
  export const getTopluNakliyeUpdateCityToTownIndexExcel = createAsyncThunk("nakliyeIndex/getTopluNakliyeUpdateCityToTownIndexExcel", async(_, thunkApi)=> {
    try {
        const {data} = await axiosInstance.get(`/NakliyeIndexs/GetNakliyeCityToTownIndexExcel`)

        const link = document.createElement('a');
        link.href = `${process.env.REACT_APP_API_EXCEL_FILES_URI}${data.data.data}`;
        document.body.appendChild(link)
        link.click();
        document.body.removeChild(link)

        return data
    } catch (error) {
        thunkApi.dispatch(setResultModalData({msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
        return thunkApi.rejectWithValue(error)
    }
  })


  //! index-5
  export const updateTopluNakliyeCityToTownIndexExcel = createAsyncThunk("nakliyeIndex/updateTopluNakliyeCityToTownIndexExcel", async(excel, thunkApi)=> {
    try {
          const file = new FormData();
          file.append("file", excel);
        const {data} = await axiosInstance.post(`/NakliyeIndexs/UpdateNakliyeCityToTownIndexExcel`, file)

        return data
    } catch (error) {
        thunkApi.dispatch(setResultModalData({msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
        return thunkApi.rejectWithValue(error)
    }
  })

//! --------------------------------------------------------------------------------------------------

//! index-6
export const getCityIklimIndex = createAsyncThunk("nakliyeIndex/getCityIklimIndex", async(cityId, thunkApi)=> {
    try {
        const {data} = await axiosInstance.get(`/NakliyeIndexs/GetNakliyeIklimIndex?cityId=${cityId}`)
        return data
    } catch (error) {
        thunkApi.dispatch(setResultModalData({msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
        return thunkApi.rejectWithValue(error)
    }
})


//! index-6
export const updateCityIklimIndex = createAsyncThunk("nakliyeIndex/updateCityIklimIndex", async(updatedList, thunkApi)=> {
    try {
        const {data} = await axiosInstance.post(`/NakliyeIndexs/UpdateNakliyeIklimIndex`, updatedList)
        if(data.statusCode === 200){
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: "Güncelleme İşlemi Başarı ile Gerçekleştirildi", resultType: "success", btnText1: "Görüntüle"}))
        }
        return data
    } catch (error) {
        thunkApi.dispatch(setResultModalData({msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
        return thunkApi.rejectWithValue(error)
    }
})

//! index-6
export const getTopluNakliyeCityIklimIndexExcel = createAsyncThunk("nakliyeIndex/getTopluNakliyeCityIklimIndexExcel", async(_, thunkApi)=> {
    try {
        const {data} = await axiosInstance.get(`/NakliyeIndexs/GetNakliyeCityTownIklimIndexExcel`)

        const link = document.createElement('a');
        link.href = `${process.env.REACT_APP_API_EXCEL_FILES_URI}${data.data.data}`;
        document.body.appendChild(link)
        link.click();
        document.body.removeChild(link)
        
        return data
    } catch (error) {
        thunkApi.dispatch(setResultModalData({msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
        return thunkApi.rejectWithValue(error)
    }
  })

  export const updateTopluNakliyeCityIklimIndexExcel = createAsyncThunk("nakliyeIndex/updateTopluNakliyeCityIklimIndexExcel", async(excel, thunkApi)=> {
    try {
          const file = new FormData();
          file.append("file", excel);
        const {data} = await axiosInstance.post(`/NakliyeIndexs/UpdateNakliyeCityTownIklimIndexExcel`, file)

        return data
    } catch (error) {
        thunkApi.dispatch(setResultModalData({msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
        return thunkApi.rejectWithValue(error)
    }
  })


  //! index 4 all price result
  export const getNakliyeHesaplamaIndex4AllResult = createAsyncThunk("nakliyeIndex/NakliyeHesaplamaIndex4AllResult", async(body, thunkApi)=> {
    try {
        const {data} = await axiosInstance.post(`/MaliyetHesabi/NakliyeHesaplamaIndex4AllResult`, body)
        return data
    } catch (error) {
        thunkApi.dispatch(setResultModalData({msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
        return thunkApi.rejectWithValue(error)
    }
  })



const nakliyeIndexSlice = createSlice({
    name: "nakliyeIndex",
    initialState,
    reducers: {

    },
    
    extraReducers:(builder)=> {
        builder

        //! getNakliyeKaynakData (index-1)
        .addCase(getNakliyeKaynakData.pending, (state)=> {
            state.isLoadingGetNakliyeKaynakData = true
        })

        .addCase(getNakliyeKaynakData.fulfilled, (state, action)=> {
            state.isLoadingGetNakliyeKaynakData = false
            state.nakliyeKaynakData = action.payload.data
        })

        .addCase(getNakliyeKaynakData.rejected, (state, action)=> {
            state.isLoadingGetNakliyeKaynakData = false
        })

        //! updateNakliyeKaynakData (index-1)
        .addCase(updateNakliyeKaynakData.pending, (state)=> {
            state.isLoadingGetNakliyeKaynakData = true
        })

        .addCase(updateNakliyeKaynakData.fulfilled, (state, action)=> {
            state.isLoadingGetNakliyeKaynakData = false
            state.nakliyeKaynakData = action.payload.data
        })

        .addCase(updateNakliyeKaynakData.rejected, (state, action)=> {
            state.isLoadingGetNakliyeKaynakData = false
        })


        //! --------------------------------------------------------------------------------------------------

        //! getNakliyeCityIndex (index-2)
        .addCase(getNakliyeCityIndex.pending, (state)=> {
            state.isLoadingGetNakliyeCityIndex = true
        })

        .addCase(getNakliyeCityIndex.fulfilled, (state, action)=> {
            state.isLoadingGetNakliyeCityIndex = false
            state.cityIndexList = action.payload.data.$values
        })

        .addCase(getNakliyeCityIndex.rejected, (state)=> {
            state.isLoadingGetNakliyeCityIndex = false
        })

        //! getTopluCityIndexExcel (index-2)
        .addCase(getTopluCityIndexExcel.pending, (state)=> {
            state.isLoadingGetTopluCityIndexExcel = true
        })

        .addCase(getTopluCityIndexExcel.fulfilled, (state)=> {
            state.isLoadingGetTopluCityIndexExcel = false
        })

        .addCase(getTopluCityIndexExcel.rejected, (state)=> {
            state.isLoadingGetTopluCityIndexExcel = false
        })

        //! updateTopluNakliyeCityIndexExcel (index-2)
        .addCase(updateTopluNakliyeCityIndexExcel.pending, (state)=> {
            state.isLoadingUpdateTopluNakliyeCityIndexExcel = true
        })

        .addCase(updateTopluNakliyeCityIndexExcel.fulfilled, (state)=> {
            state.isLoadingUpdateTopluNakliyeCityIndexExcel = false
        })

        .addCase(updateTopluNakliyeCityIndexExcel.rejected, (state)=> {
            state.isLoadingUpdateTopluNakliyeCityIndexExcel = false
        })

        //! --------------------------------------------------------------------------------------------------

        //! getNakliyeSeasonIndex (index-3)
        .addCase(getNakliyeSeasonIndex.pending, (state)=> {
            state.isLoadingGetNakliyeSeasonIndex = true
            state.cityTownSeasonIndex = []
        })

        .addCase(getNakliyeSeasonIndex.fulfilled, (state, action)=> {
            state.isLoadingGetNakliyeSeasonIndex = false
            state.cityTownSeasonIndex = action.payload.data?.$values
        })

        .addCase(getNakliyeSeasonIndex.rejected, (state, action)=> {
            state.isLoadingGetNakliyeSeasonIndex = false
        })


        //! getTopluNakliyeSeasonIndexExcel (index-3)
        .addCase(getTopluNakliyeSeasonIndexExcel.pending, (state)=> {
            state.isLoadingGetTopluNakliyeSeasonIndexExcel = true
        })

        .addCase(getTopluNakliyeSeasonIndexExcel.fulfilled, (state)=> {
            state.isLoadingGetTopluNakliyeSeasonIndexExcel = false
        })

        .addCase(getTopluNakliyeSeasonIndexExcel.rejected, (state)=> {
            state.isLoadingGetTopluNakliyeSeasonIndexExcel = false
        })

        //! updateTopluNakliyeSeasonIndexExcel (index-3)
        .addCase(updateTopluNakliyeSeasonIndexExcel.pending, (state)=> {
            state.isLoadingUpdateTopluNakliyeSeasonIndexExcel = true
        })

        .addCase(updateTopluNakliyeSeasonIndexExcel.fulfilled, (state, action)=> {
            state.isLoadingUpdateTopluNakliyeSeasonIndexExcel = false
        })

        .addCase(updateTopluNakliyeSeasonIndexExcel.rejected, (state, action)=> {
            state.isLoadingUpdateTopluNakliyeSeasonIndexExcel = false
        })

        //! --------------------------------------------------------------------------------------------------

        //! getCityToCityIndex (index-4)
        .addCase(getCityToCityIndex.pending, (state)=> {
            state.isLoadingGetCityToCityIndex = true
            state.cityTownSeasonIndex = []
        })

        .addCase(getCityToCityIndex.fulfilled, (state, action)=> {
            state.isLoadingGetCityToCityIndex = false
            state.cityToCityIndex = {...action.payload.data?.$values[0], toCityIndex: action.payload.data?.$values[0].toCityIndex.$values}
        })

        .addCase(getCityToCityIndex.rejected, (state, action)=> {
            state.isLoadingGetCityToCityIndex = false
        })


        //! getTopluNakliyeCityToCityIndexExcel (index-4)
        .addCase(getTopluNakliyeCityToCityIndexExcel.pending, (state)=> {
            state.isLoadingGetTopluNakliyeCityToCityIndexExcel = true
        })

        .addCase(getTopluNakliyeCityToCityIndexExcel.fulfilled, (state, action)=> {
            state.isLoadingGetTopluNakliyeCityToCityIndexExcel = false
        })

        .addCase(getTopluNakliyeCityToCityIndexExcel.rejected, (state, action)=> {
            state.isLoadingGetTopluNakliyeCityToCityIndexExcel = false
        })

        //! updateTopluNakliyeCityToCityIndexExcel (index-4)
        .addCase(updateTopluNakliyeCityToCityIndexExcel.pending, (state)=> {
            state.isLoadingUpdateTopluNakliyeCityToCityIndexExcel = true
        })

        .addCase(updateTopluNakliyeCityToCityIndexExcel.fulfilled, (state, action)=> {
            state.isLoadingUpdateTopluNakliyeCityToCityIndexExcel = false
        })

        .addCase(updateTopluNakliyeCityToCityIndexExcel.rejected, (state, action)=> {
            state.isLoadingUpdateTopluNakliyeCityToCityIndexExcel = false
        })

        //! --------------------------------------------------------------------------------------------------

        //! getCityToTownIndex (index-5)
        .addCase(getCityToTownIndex.pending, (state)=> {
            state.isLoadingGetCityToTownIndex = true
            state.cityTownSeasonIndex = []
        })

        .addCase(getCityToTownIndex.fulfilled, (state, action)=> {
            state.isLoadingGetCityToTownIndex = false
            state.cityToTownIndex = {...action.payload.data?.$values[0], toTownIndex: action.payload.data?.$values[0].toTownIndex.$values}
        })

        .addCase(getCityToTownIndex.rejected, (state, action)=> {
            state.isLoadingGetCityToTownIndex = false
        })

        //! getTopluNakliyeUpdateCityToTownIndexExcel (index-5)
        .addCase(getTopluNakliyeUpdateCityToTownIndexExcel.pending, (state)=> {
            state.isLoadingGetTopluNakliyeUpdateCityToTownIndexExcel = true
        })

        .addCase(getTopluNakliyeUpdateCityToTownIndexExcel.fulfilled, (state, action)=> {
            state.isLoadingGetTopluNakliyeUpdateCityToTownIndexExcel = false
        })

        .addCase(getTopluNakliyeUpdateCityToTownIndexExcel.rejected, (state, action)=> {
            state.isLoadingGetTopluNakliyeUpdateCityToTownIndexExcel = false
        })


        //! updateTopluNakliyeSeasonIndexExcel (index-5)
        .addCase(updateTopluNakliyeCityToTownIndexExcel.pending, (state)=> {
            state.isLoadingUpdateTopluNakliyeCityToTowIndexExcel = true
        })

        .addCase(updateTopluNakliyeCityToTownIndexExcel.fulfilled, (state, action)=> {
            state.isLoadingUpdateTopluNakliyeCityToTowIndexExcel = false
        })

        .addCase(updateTopluNakliyeCityToTownIndexExcel.rejected, (state, action)=> {
            state.isLoadingUpdateTopluNakliyeCityToTowIndexExcel = false
        })
        
        //! --------------------------------------------------------------------------------------------------


        //! getCityIklimIndex (index-6)
        .addCase(getCityIklimIndex.pending, (state)=> {
            state.isLoadingGetNakliyeIklimIndex = true
            state.nakliyeIklimIndex = []
        })

        .addCase(getCityIklimIndex.fulfilled, (state, action)=> {
            state.isLoadingGetNakliyeIklimIndex = false
            state.cityIklimIndex = action.payload.data.$values
        })

        .addCase(getCityIklimIndex.rejected, (state, action)=> {
            state.isLoadingGetNakliyeIklimIndex = false
        })


        //! getTopluNakliyeCityIklimIndexExcel (index-6)
        .addCase(getTopluNakliyeCityIklimIndexExcel.pending, (state)=> {
            state.isLoadingGetTopluNakliyeCityIklimIndexExcel = true
        })

        .addCase(getTopluNakliyeCityIklimIndexExcel.fulfilled, (state, action)=> {
            state.isLoadingGetTopluNakliyeCityIklimIndexExcel = false
        })

        .addCase(getTopluNakliyeCityIklimIndexExcel.rejected, (state, action)=> {
            state.isLoadingGetTopluNakliyeCityIklimIndexExcel = false
        })

        //! updateTopluNakliyeCityIklimIndexExcel (index-6)
        .addCase(updateTopluNakliyeCityIklimIndexExcel.pending, (state)=> {
            state.isLoadingUpdateTopluNakliyeCityIklimIndexExcel = true
        })

        .addCase(updateTopluNakliyeCityIklimIndexExcel.fulfilled, (state, action)=> {
            state.isLoadingUpdateTopluNakliyeCityIklimIndexExcel = false
        })

        .addCase(updateTopluNakliyeCityIklimIndexExcel.rejected, (state, action)=> {
            state.isLoadingUpdateTopluNakliyeCityIklimIndexExcel = false
        })


        //! getNakliyeHesaplamaIndex4AllResult
        .addCase(getNakliyeHesaplamaIndex4AllResult.pending, (state)=> {
            state.isLoadingGetNakliyeHesaplamaIndex4AllResult = true
        })

        .addCase(getNakliyeHesaplamaIndex4AllResult.fulfilled, (state, action)=> {
            state.isLoadingGetNakliyeHesaplamaIndex4AllResult = false
            state.nakliyeHesaplamaIndex4AllResult = action.payload.data.$values
        })

        .addCase(getNakliyeHesaplamaIndex4AllResult.rejected, (state, action)=> {
            state.isLoadingGetNakliyeHesaplamaIndex4AllResult = false
        })
        

        
        
    }
})


export const {} = nakliyeIndexSlice.actions
export default nakliyeIndexSlice.reducer
